// Aspirants: new people proposed for blåtur. Without Firebase dependencies so the rules can be unit tested.
//
// - Anyone on the invitation list can propose an aspirant, and anyone on the list can veto.
// - An aspirant is ready when they have met at least REQUIRED_MET people from the invitation list
//   at other events than blåtur (both registered as host or participant on the same event).
// - A veto blocks admission until it is withdrawn, or this year's organizers override it.

import { BLATUR_TYPE } from './tripHelpers';

export const REQUIRED_MET = 8;

const normalize = (name) => (name || '').trim().toLowerCase();

// Names from memberNames the aspirant has been on a non-blåtur event with
export function membersMet(aspirantName, events, memberNames) {
  const me = normalize(aspirantName);
  const members = new Map(memberNames.map(n => [normalize(n), n.trim()]));
  const met = new Map();
  for (const event of events) {
    if (event.event_type === BLATUR_TYPE) continue;
    const people = [...(event.Deltagelse || []), ...(event.Vert || [])].map(normalize);
    if (!people.includes(me)) continue;
    people.forEach(p => {
      if (p !== me && members.has(p)) met.set(p, members.get(p));
    });
  }
  return [...met.values()].sort((a, b) => a.localeCompare(b, 'no'));
}

export function aspirantStatus(aspirant, events, memberNames) {
  const met = membersMet(aspirant.name, events, memberNames);
  const vetoes = Object.entries(aspirant.vetoes || {}).map(([uid, v]) => ({ uid, ...v }));
  return {
    met,
    ready: met.length >= REQUIRED_MET,
    vetoes,
    blocked: vetoes.length > 0,
  };
}
